<!-- <button *ngIf="!visible" (click)="getDetails()">Get Details</button> -->
<ng-container id="üstMenü">
  <div *ngIf="visible">
    <ng-container *ngFor="let item of inventionDetailData; let i = index">
      Buluş Adı:{{ item.inventionName }}
    </ng-container>
  </div>
  <div *ngIf="visible">
    <ng-container *ngFor="let item of inventionDetailData; let i = index">
      Dosya No:{{ item.documentNumber }}
    </ng-container>
  </div>
  <!-- <div *ngIf="visible">
  <span *ngFor="let item of inventionDetailData; let i = index">
    Dosya Durumu:{{ status }}
  </span>
</div> -->
  <!-- <ng-container style="font-size: 18px">
    ilk Başvuru/Ülkesel Giriş: {{ selectedCountry.patentType }}</ng-container
  > -->

  <ng-container style="font-size: 18px">
    Ülke Adı: {{ selectedCountry.patentCountry }}
  </ng-container>
</ng-container>
<p></p>
<ng-container style="margin-left: -19%">
  <button class="btn" (click)="navigate()">Üst Menüye Git</button>
</ng-container>

<p></p>

<div *ngIf="visible">
  <ng-container id="yanMenü">
    <ul>
      <li>
        <a class="nav-item nav-link" (click)="summary()">
          {{ selectedCountry.patentCountry }} Özet
        </a>
      </li>
      <li>
        <a class="nav-item nav-link" (click)="documents()"
          >{{ selectedCountry.patentCountry }} Dosyalar</a
        >
      </li>
      <li>
        <a class="nav-item nav-link" (click)="timeLimits()"
          >{{ selectedCountry.patentCountry }} Kayıtları</a
        >
      </li>

      <li>
        <a class="nav-item nav-link" (click)="decision()"
          >{{ selectedCountry.patentCountry }} Güncelle</a
        >
      </li>

    </ul>
  </ng-container>
</div>

<div>

  <div class="row" id="data">
    <div  *ngIf="visibleSummary">
    <button
    class="btn btn-dark"
    (click)="countryEdit()"
    style="
      margin-left: 0%;

      font-size: 18px;
      display: block;
    "
  >
  Ülkesel Kaydı Güncelle
  </button></div>
  <p></p>
  <p></p>
    <div *ngIf="visibleSummary">

        <h4>Ülke Patent Bilgileri:</h4>


      <p>
        Ülkedeki Buluşun Adı:
        {{ selectedCountry.patentName }}
      </p>

      <p>
        Ülkedeki Buluşun Başvuru Tarihi:{{
          selectedCountry.patentDate | date: "dd/MM/yyyy"
        }}
      </p>
      <p>
        Ülkedeki Buluşun Buluş Numarası:{{ selectedCountry.patentCountry }}-{{
          selectedCountry.patentNumber
        }}
      </p>

      <p *ngIf="selectedCountry.priority">
        Buluşun Bağlı Olduğu Patentin Ülkesi/Numarası:
        {{ selectedCountry.priority.country }}/{{
          selectedCountry.priority.number
        }}
      </p>
      <p>Ülkedeki Buluşun Son Durumu:{{ countryLastStatus }}</p>
      <p>Ülkedeki Buluşun Özeti:{{ selectedCountry.abstract }}</p>
      <p>Ülkeye İlişkin Notlar: {{selectedCountry.countryNote}}</p>
    </div>
  </div>
  <table *ngIf="visibleTimeLimits" style="margin-left: 23%">
    <thead>
      <th>No.</th>
      <th>Patent Türü</th>
      <th>Durum</th>
      <th>Alınan Aksiyonun Tarihi</th>
      <th>Aksiyonu alan kişi</th>
      <th>Alınan Aksiyon Üzerinden Geçen Süre</th>
      <th></th>
    </thead>
    <tbody>
      <tr *ngFor="let item of countryStatusList; let i = index">
        <td>{{ i + 1 }}</td>
        <td>{{selectedCountry.patentType}}</td>
        <td>{{ item.status }}</td>
        <td>{{ item.date | date: "dd/MM/yyyy" }}</td>
        <td>{{ item.recordigUser }}</td>
        <td>{{ item.date | DayAgo }}</td>
        <td><button (click)="deleteStatusRecord(i)">Kaydı Sil</button></td>
      </tr>
    </tbody>
  </table>

  <div *ngIf="visibleDecision" id="data">

    <ng-container *ngIf="visibleDecision ">


      <div >
        <h3 style="color: #d70040">Ülkesel Durum:</h3>


        <select
          name="countryRecLastStatus"
          [(ngModel)]="countryRecLastStatus"
(ngModelChange)="checkTheLastSatusForPatentNumber($event)"
          id="countryName"
        >

        <option value="">

        </option>
          <option value="başvuru" >Başvuru

          </option>
          <option value="şekli eksiklik">Şekli Eksiklik

          </option>
          <option value="şekli uygunluk">Şekli Uygunluk

          </option>
          <option value="resmi araştırma talep">Resmi Araştırma Talep

          </option>
          <option value="resmi araştırma rapor">Resmi Araştırma Rapor

          </option>

          <option value="resmi inceleme talep">Resmi İnceleme Talep

          </option>
          <option value="resmi inceleme rapor">Resmi İnceleme Rapor

          </option>
          <option value="yayın">Yayın

          </option>
          <option value="iptal">İptal

          </option>
          <option value="tescil">Tescil

          </option>
          <option value="belge kararı">Belge Kararı

          </option>
          <option value="belge düzenleme">Belge Düzenleme

          </option>
          <option value="kullanma bildirimi">Kullanma Bildirimi

          </option>
        </select>

</div>

    <div *ngIf="addPatentNumberField">
<p></p>

      <div style="text-transform:capitalize; padding-right: 15px;float:left; color: #d70040;"><h4>{{countryRecLastStatus}} No:</h4>

      </div>
      <div >
      <input
      [(ngModel)]="countryPatentNumber"
      class="form-control"
      type="text"
      style="width:250px ;"
      placeholder="Başvuru Numarasını Giriniz"
    /></div>
  </div>

<div >
        <h3 style="color: #d70040" >İşlemin Gerçekleştiği Tarih:</h3>
        <input
          [(ngModel)]="countryRecordDate"
          type="date"
          id="priorityDate"
          placeholder="{{ countryRecordDate }}"
        />
      </div>

      <!-- <button
          [disabled]="!value"
          class="btn btn-success"
          (click)="updateStatusSendEmail()"
        >
          Durumu Güncelle ve Buluş Sahiplerine bilgi e-postası at.
        </button> -->
    </ng-container>

    <ng-container *ngIf="visibleDecision ">
      <div>
        <h3 style="color: #d70040">Patent Türü:</h3>
        <div class="form-check">
          <input
            [(ngModel)]="countryLastInventionType"
            class="form-check-input"
            type="radio"
            value="incelemeli patent"
            name="countryLastInventionType"
          />
          <h6 class="form-check-label">İncelemeli Patent</h6>
        </div>
        <div class="form-check">
          <input
            [(ngModel)]="countryLastInventionType"
            class="form-check-input"
            type="radio"
            value="incelemesiz patent"
            name="countryLastInventionType"
          />
          <h6 class="form-check-label">İncelemesiz Patent</h6>
        </div>
        <div class="form-check">
          <input
            [(ngModel)]="countryLastInventionType"
            class="form-check-input"
            type="radio"
            value="faydalı model (araştırma raporlu)"
            name="countryLastInventionType"
          />
          <h6 class="form-check-label">Faydalı Model (Araştırma Raporlu)</h6>
        </div>
        <div class="form-check">
          <input
            [(ngModel)]="countryLastInventionType"
            class="form-check-input"
            type="radio"
            value="faydalı model (araştırma raporsuz)"
            name="countryLastInventionType"
          />
          <h6 class="form-check-label">Faydalı Model (Araştırma Raporsuz)</h6>
        </div>

        <button
          [disabled]="!countryRecordDate"
          class="btn btn-success"
          (click)="updateStatus()"
          style="
            margin-left: auto;
            margin-right: 20%;
            font-size: 18px;
            display: block;
            background-color: #0275d8;
          "
        >
          Durumu Güncelle
        </button>
      </div>

      <!-- <button
          [disabled]="!value"
          class="btn btn-success"
          (click)="updateStatusSendEmail()"
        >
          Durumu Güncelle ve Buluş Sahiplerine bilgi e-postası at.
        </button> -->
    </ng-container>
    <span *ngIf="isStatusUpdated">
      <button class="btn" (click)="navigate()">Üst Menüye Git</button>
    </span>
  </div>

  <div>
    <table
      *ngIf="visibleDocuments && !foldertoggle && !valid"
      style="margin-left: 23%"
    >
      <thead>
        <th>No.</th>
        <th>Dosyanın Türü</th>
        <th>Dosya Adı</th>
        <th>Dosyanın Yüklenme Tarihi</th>
        <th>Yüklenme Tarihi Üzerinden Geçen Süre</th>
        <th>Dosya İndir</th>
      </thead>
      <tbody>
        <tr *ngFor="let item of countryDocLink; let i = index">
          <td>{{ i + 1 }}</td>
          <td>{{ item.type }}</td>

          <td>{{ item.docName }}</td>
          <td>{{ item.date | date: "dd/MM/yyyy" }}</td>
          <td>{{ item.date | DayAgo }}</td>

          <td>
            <a class="nav-item nav-link" href="{{ item.link }}" target="_blank">
              Detaylar
            </a>
          </td>
          <td style="background-color: #f8f9fb">
            <button type="button" class="btn" (click)="deleteFolder(i)">
              Dosyayı Sil
            </button>
          </td>
        </tr>
      </tbody>
    </table>
  </div>
  <div id="dataButton" *ngIf="visibleDocuments">
    <br />

    <button
      *ngIf="!foldertoggle && !valid"
      for="file"
      (click)="onFolderToggle()"
      type="button"
      class="btn"
      style="font-size: 18px"
    >
      Yeni Dosya Yükle
    </button>
    <h1>{{ errorText }}</h1>
    <span *ngIf="valid">
      <button class="btn" (click)="navigate()">Üst Menüye Git</button>
    </span>
    <button
      class="btn btn-success"
      *ngIf="foldertoggle && !valid"
      (click)="onFolderToggle()"
    >
      Dosyalara geri dön
    </button>

    <hr />
    <ng-container *ngIf="foldertoggle && !valid">
      <h1 for="file" style="color: #d70040">Yeni Dosya Yükleme</h1>
      <h3 for="file" style="color: #d70040">Dosya Türünü Seçiniz</h3>
      <p></p>
      <div class="form-check">
        <input
          [(ngModel)]="fileName"
          class="form-check-input"
          type="radio"
          value="resmi ofis yazısı"
        />
        <div class="form-check-label">Resmi Ofis Yazısı</div>
      </div>
      <div class="form-check">
        <input
          [(ngModel)]="fileName"
          class="form-check-input"
          type="radio"
          value="vekil yazısı"
        />
        <div class="form-check-label">Vekil Yazısı</div>
      </div>
      <div class="form-check">
        <input
          [(ngModel)]="fileName"
          class="form-check-input"
          type="radio"
          value="çeviri evrakı"
        />
        <div class="form-check-label">Çeviri Evrakı</div>
      </div>
      <!-- <button class="btn btn-primary" (click)="formName()">
          Dosya Adını Kendim Belirleyeceğim
        </button>
        <ng-container *ngIf="otherForm">
          <h3 for="file">İstediğiniz Dosya Adını Yazınız.</h3>
          <input type="text" [(ngModel)]="fileName" />
        </ng-container> -->
      <br />
      <div>
        <h3 style="color: #d70040">Gelen/Gönderilen dosya</h3>
        <p></p>
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            value="gelen dosya"
            name="Gönderi"
            [(ngModel)]="myRadio"
          />
          <div class="form-check-label">Gelen Dosya</div>
        </div>
        <p></p>
        <div class="form-check">
          <input
            type="radio"
            class="form-check-input"
            value="giden dosya"
            name="Gönderi"
            [(ngModel)]="myRadio"
          />
          <div class="form-check-label">Gönderilen Dosya</div>
        </div>
      </div>
      <p></p>

      <input type="file" (change)="upload($event)" accept="*.pdf" /><br />

      <button
        [disabled]="myRadio === '' || fileName === '' || !isFolderLoaded"
        class="btn"
        (click)="uplodFolder()"
        style="
          background-color: #28384f;
          font-size: 18px;
          display: block;
          margin-left: auto;
          margin-right: 20%;
        "
      >
        Dosyayı Yükle
      </button>
    </ng-container>
  </div>

  <!--Recorded Patents -->
  <div *ngIf="visiblePatents">
    <table style="margin-left: 21%">
      <thead>
        <th>No.</th>
        <th>Buluş Tipi</th>

        <th>İlgili Ülke</th>
        <th>Giriş Tarihi</th>
        <th>Buluş Başlığı</th>
        <!-- <th>Buluş Özeti</th> -->
        <th>1.İstem</th>
        <th>Son Güncelleme</th>
        <th>Son Durum</th>
        <th></th>
      </thead>
      <tbody>
        <tr *ngFor="let item of patentInfo; let i = index">
          <td
            [style.color]="
              item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
            "
          >
            {{ i + 1 }}
          </td>
          <td
            [style.color]="
              item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
            "
          >
            {{ item.patentType }}
          </td>

          <td
            [style.color]="
              item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
            "
          >
            {{ item.patentCountry }}
          </td>
          <td
            [style.color]="
              item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
            "
          >
            {{ item.patentDate }}
          </td>
          <td
            [style.color]="
              item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
            "
          >
            {{ item.patentName }}
          </td>
          <!-- <td>{{ item.abstract }}</td> -->
          <td
            [style.color]="
              item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
            "
          >
            {{ item.firstClaim }}
          </td>
          <td
            [style.color]="
              item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
            "
          >
            {{ item.patentStatus[0].date | DayAgo }}
          </td>
          <td
            [style.color]="
              item.patentStatus.slice(-1)[0].status === 'İptal' ? 'red' : ''
            "
          >
            {{ item.patentStatus.slice(-1)[0].status}}
          </td>

          <!-- <td>{{ item.date | date: "dd/MM/yyyy" }}</td>
        <td>{{ item.date | DayAgo }}</td>
        <td>
          <a class="nav-item nav-link" href="{{ item.link }}" target="_blank">
            Detaylar
          </a>
        </td>-->
          <td>
            <button class="btn" (click)="deletePatent(i)">
              Ülkesel Girişi Sil
            </button>
            <button class="btn" (click)="enterCountry(i)">
              Ülkesel Girişi Görüntüle
            </button>
          </td>
        </tr>
      </tbody>
    </table>
    <button
      class="btn btn-primary"
      style="margin-right: 30%"
      (click)="recordPatent()"
    >
      Patent Kaydı Ekle
    </button>
  </div>
</div>
